import React from 'react';
import {post} from "./js/api";

class GlobalErrorBoundary extends React.Component {
    componentDidCatch(error, info) {
        const error_data = {
            url: document.location.href,
            name: error.name,              // e.g. TypeError
            message: error.message,
            stack: error.stack,
            componentStack: info.componentStack, // React-specific
        };

        post('/logs/logerror', error_data)
            .then(() => {
                console.log('Successfully logged React error');
            });
    }

    render() {
        return this.props.children;
    }
}

export default GlobalErrorBoundary;